export default {"src":"/_next/static/media/logo.1451f335.svg","height":60,"width":96};